import { Practice } from 'EntityTypes';
import { RootState } from 'StoreTypes';

// @ts-expect-error ts-migrate(2322) FIXME: Type 'Practice | undefined' is not assignable to t... Remove this comment to see the full error message
export const getCurrentPractice = (state: RootState): Practice => state.practice;

// @ts-expect-error ts-migrate(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
export const getPracticeId = (state: RootState): number => state.practice?.id;
